'use client'
import narrativeMd from './markdown/narrative.md';
import raceMd from './markdown/race.md';
import slowdownMd from './markdown/slowdown.md';
import ArticleContent from './app/ArticleContent';
import { makeEndingViews } from '../endingViews';

const views = makeEndingViews({
  locale: 'ja',
  narrativeMd,
  raceMd,
  slowdownMd,
  ArticleContent,
});

export const RaceView = views.RaceView;
export const SlowdownView = views.SlowdownView;
